const pageNameKey = "infoIconAndText";

export const infoIconAndTextEn = {
  [pageNameKey]: {
    infoIconAndTextAltText: "Info Icon",
  },
};

export const infoIconAndTextPtBr = {
  [pageNameKey]: {
    infoIconAndTextAltText: "Ícone de informação",
  },
};

export const infoIconAndTextDe = {
  [pageNameKey]: {
    infoIconAndTextAltText: "Info-Symbol",
  },
};

export const infoIconAndTextZhHans = {
  [pageNameKey]: {
    infoIconAndTextAltText: "信息图标",
  },
};

export const infoIconAndTextIt = {
  [pageNameKey]: {
    infoIconAndTextAltText: "Icona Info",
  },
};

export const infoIconAndTextEs = {
  [pageNameKey]: {
    infoIconAndTextAltText: "Icono de información",
  },
};

export const infoIconAndTextNl = {
  [pageNameKey]: {
    infoIconAndTextAltText: "Info-pictogram",
  },
};

export const infoIconAndTextTr = {
  [pageNameKey]: {
    infoIconAndTextAltText: "Bilgi Simgesi",
  },
};
